import React from "react";
import clsx from "clsx";

const STATUS_LABELS = {
  planned: "Planned",
  in_progress: "In Prog",
  done: "Done",
  blocked: "Blocked",
  spilled: "Spilled",
  cancelled: "Cancel",
};

const STATUS_STYLES = {
  planned: "bg-bg-elevated text-ink-dim border-line",
  in_progress: "bg-amber-glow text-amber border-amber",
  done: "bg-transparent text-ink-mute border-line",
  blocked: "bg-red-glow text-red border-red",
  spilled: "bg-cyan-glow text-cyan border-cyan",
  cancelled: "bg-transparent text-ink-ghost border-line line-through",
};

const STATUS_CYCLE = ["planned", "in_progress", "done"];

export default function StatusPill({ status, onChange, dataTestid }) {
  const s = status || "planned";
  const handleClick = (e) => {
    e.stopPropagation();
    if (!onChange) return;
    if (STATUS_CYCLE.includes(s)) {
      const idx = STATUS_CYCLE.indexOf(s);
      const next = STATUS_CYCLE[(idx + 1) % STATUS_CYCLE.length];
      onChange(next);
    } else {
      onChange("planned");
    }
  };

  const handleContext = (e) => {
    // For now we just let the parent handle right-click (cell history drawer)
    // Full menu can be added later.
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      onContextMenu={handleContext}
      className={clsx("status-pill", STATUS_STYLES[s])}
      data-testid={dataTestid}
    >
      {s === "in_progress" && <span className="w-1.5 h-1.5 bg-amber rounded-full animate-pulse-amber inline-block" />}
      {STATUS_LABELS[s]}
    </button>
  );
}
